import { useMemo } from 'react'
import { useCheckFanduelRSN } from './useCheckFanduelRSN'
import { PlanTypes } from 'src/constants/standaloneData'
import { useIsRSNAvailable } from './useIsRSNAvailable'
import { useFormatFanduelData } from './useFormatFanduelData'
import { usPlanData } from 'src/constants/planData/usPlanData'

export const useIsStandaloneAvailable = ({ sportType = null }) => {
  const { isAvailable: isFanduelAvailable, rsnData: fanduelData } = useCheckFanduelRSN({
    sportType,
  })

  // Only check MASN if FanDuel is not available
  const { isAvailable: isChicagoSportsNetworkAvailable } = useIsRSNAvailable(
    !isFanduelAvailable ? PlanTypes.CHICAGO_SPORTS_NETWORK : null
  )

  const fdPlanData = useFormatFanduelData(usPlanData.fanduel_standalone_monthly, fanduelData)
  // Use useMemo to derive the available data based on priority
  return useMemo(() => {
    const isAvailable = isFanduelAvailable || isChicagoSportsNetworkAvailable
    const planData = isFanduelAvailable
      ? fdPlanData
      : isChicagoSportsNetworkAvailable
        ? usPlanData.chicago_sports_network_monthly
        : null
    const teams = planData?.teams
    return {
      isAvailable,
      planData,
      teams,
      rsns: isChicagoSportsNetworkAvailable
        ? ['chsn']
        : isFanduelAvailable
          ? ['fanduelsports']
          : [],
    }
  }, [isFanduelAvailable, isChicagoSportsNetworkAvailable, fdPlanData])
}
